module.exports = __webpack_public_path__ + "static/img/cover.32955bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/cover.png
// module id = qd5P
// module chunks = 3